export default __webpack_public_path__ + "static/s-02-4d0ef387e5e663ef7b15314603f83899.png";